import { copy } from "shared/assets";
import { IFieldType, IFormFields } from "shared/types";

const { placeProperties, errors } = copy;

export const fields: IFormFields = [
  {
    name: "title",
    label: placeProperties.title.title,
    type: IFieldType.text,
    validation: {
      required: errors.required,
    },
  },
];
